import { render, staticRenderFns } from "./XAudioPlayer.vue?vue&type=template&id=9470633e&scoped=true"
import script from "./XAudioPlayer.vue?vue&type=script&lang=js"
export * from "./XAudioPlayer.vue?vue&type=script&lang=js"
import style0 from "./XAudioPlayer.vue?vue&type=style&index=0&id=9470633e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9470633e",
  null
  
)

export default component.exports